export default {
	methods: {
		scrollTopByWindow() {
			return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
		},
		getAbsoluteOffsetTop(element) {
			let totalOffset = 0;
			while (element) {
				totalOffset += element.offsetTop;
				element = element.offsetParent;
				if (element && element.style && element.style.borderTopWidth) {
					totalOffset += parseInt(element.style.borderTopWidth, 10);
				}
			}
			return totalOffset;
		},
	},
}
